import { MessageSquareText } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { QUICK_PHRASES } from "@/lib/phrases";

export const QuickPhrasesSheet = ({ onPick }) => (
  <Sheet>
    <SheetTrigger asChild>
      <button
        type="button"
        data-testid="quick-phrases-modal-trigger"
        className="flex h-11 items-center gap-2 rounded-full border border-slate-600 bg-slate-800/80 px-4 text-sm font-semibold text-white transition-colors hover:bg-slate-700"
      >
        <MessageSquareText className="h-4 w-4 text-amber-400" />
        Frases rápidas
      </button>
    </SheetTrigger>
    <SheetContent side="bottom" className="max-h-[80vh] overflow-y-auto border-slate-700 bg-[#1c2541] text-white" data-testid="quick-phrases-sheet">
      <SheetHeader>
        <SheetTitle className="text-white">Frases rápidas policiales · sin coste de traducción</SheetTitle>
      </SheetHeader>
      <div className="mt-4 grid gap-6 sm:grid-cols-2">
        {QUICK_PHRASES.map((cat) => (
          <div key={cat.category}>
            <h3 className="mb-2 text-xs font-semibold uppercase tracking-widest text-amber-400">{cat.category}</h3>
            <ul className="flex flex-col gap-2">
              {cat.items.map((p, i) => (
                <li key={p.es}>
                  <button
                    type="button"
                    data-testid={`quick-phrase-${cat.category.slice(0, 4).toLowerCase()}-${i}`}
                    onClick={() => onPick(p)}
                    className="w-full rounded-xl border border-slate-700 bg-slate-900/60 px-4 py-3 text-left transition-colors hover:border-amber-500/60 hover:bg-slate-800"
                  >
                    <span className="block text-base font-medium">{p.es}</span>
                    <span dir="rtl" className="font-arabic mt-1 block text-lg text-amber-200">
                      {p.ar}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </SheetContent>
  </Sheet>
);
